export const SENSITIVE_URL_PARAMS = [
  "code", "auth_token", "registration_token", "parent_key"
];

// Works for absolute URLs, relative URLs, query strings and URLs embedded in
// error messages. No URL parser exception can return an unsanitized credential.
export function stripSensitiveParams(value: string): string {
  return value.replace(
    /([?&]|%3[fF]|%26)(code|auth_token|registration_token|parent_key)(=|%3[dD])[^&#\s"'<>]*/gi,
    "$1$2$3[REDACTED]"
  ).replace(/("parent_?key"\s*:\s*")[^"\r\n]*(")/gi, "$1[REDACTED]$2");
}

// Covers custom properties, breadcrumbs, replay metadata, network URLs and
// Sentry spans, as well as standard current_url/referrer properties.
export function sanitizeTelemetry<T>(value: T): T {
  if (typeof value === "string") return stripSensitiveParams(value) as T;
  if (Array.isArray(value)) return value.map(sanitizeTelemetry) as T;
  if (value && typeof value === "object") {
    return Object.fromEntries(Object.entries(value).map(([key, item]) => [
      key,
      /^(parent_?key)$/i.test(key) ? "[REDACTED]" : sanitizeTelemetry(item)
    ])) as T;
  }
  return value;
}
